import { render, staticRenderFns } from "./Transcription.vue?vue&type=template&id=7cb63ab4&"
import script from "./Transcription.vue?vue&type=script&lang=js&"
export * from "./Transcription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports